import { AmbitConfig } from './../../services/global/global.service';
import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { IonContent, AlertController } from '@ionic/angular';  // renamed from Content
import { InAppBrowser } from '@ionic-native/in-app-browser';

// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service';  // workaround for events

// need to route to another page programmatically
import { Router } from '@angular/router';  // forward to another page

import { ApiService } from 'src/app/services/api/api.service';
import { TranslateService } from '@ngx-translate/core';
//import { ApiService } from 'src/app/services/api/api.service';
import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { RuntimeService } from 'src/app/services/runtime/runtime.service';
import { MonitorSession } from 'src/app/services/monitoring/monitoringsession';
//import { Subscription } from 'rxjs';
import { GeoPosition, GeoStatus } from 'src/app/services/geolocation/geoposition';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { MonitoringService } from 'src/app/services/monitoring/monitoring.service';
import { GeolocationWrapperService } from 'src/app/services/geolocation/geolocation.service';
import { NotificationData } from 'src/app/services/global/structure';

// add global variables here
import * as Constants from 'src/app/services/constants/constants';
import { MygeoinfoComponent } from '../mygeoinfo/mygeoinfo.component';

@Component({
  selector: 'myfooter',
  templateUrl: './myfooter.component.html',
  styleUrls: ['./myfooter.component.scss'],
})
export class MyfooterComponent implements OnInit, OnDestroy  {
  
  constructor(private alertController: AlertController
    , public globalProvider:GlobalService
    //, private connectivityProvider: ConnectivityProvider
    , private notificationProvider: NotificationService
    , private monitoringProvider: MonitoringService
    , private geolocationProvider: GeolocationWrapperService
    , public translate: TranslateService
    , public zone: NgZone 
    , public events: Events
    , public router: Router
    , public apiProvider: ApiService
    , private runtime: RuntimeService
    // public navCtrl: NavController, public navParams: NavParams
  ) 
  {
    this.consoleLog = this.globalProvider.consoleLog_myfooter;
    if (this.consoleLog) console.log('myfooter.ctor - LifeCycle');
  }

  @ViewChild(IonContent) content: IonContent;   
  @ViewChild(MygeoinfoComponent ) mygeoinfocomponent: MygeoinfoComponent;
  // https://toddmotto.com/component-events-event-emitter-output-angular-2
  @Input() pageName:string; //@Input('pageName') pageName;
  @Output() outIsDashboardRefresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  consoleLog:boolean = false;

  // specific page information (technical identifier stuff)
  public isPanic:boolean = false;
  public isMonitoring:boolean = false;
  private monitorSession:MonitorSession = new MonitorSession();
  public isPanicModeOnlyAndPanicScreen:boolean = false;
  //public PanicShowStartButtonFlag: boolean = false;

  public isNotification:boolean = false;
  public isNotificationViewEnabled:boolean = false;
  
  public alertLevel:string = 'LOW';
  public alertMessage:string = '';
  public isAlertLevelEnabled:boolean = false;

  public isGpsWatching:boolean = false;
  public isIpsWatching:boolean;
  public showFooterGeo:boolean = false;

  public dotGpsUrl:string = "assets/imgs/dotGps.png";
  public dotIpsUrl:string = "assets/imgs/dotIps.png";

  private NotificationData:NotificationData;
  public SurveyBroadcastId:number = 0;
  

  // ----------------------------------------------------
  // --------------- LOCATION CONTROLLER WATCH ----------
  // ----------------------------------------------------

  // https://forum.ionicframework.com/t/events-pub-sub-how-to-unsubscribe-in-lifecycle-hook/50596/5?u=xme
  private _GpsEventSub: (geoStatus:GeoStatus) => void;

  // ----------------------------------------------------
  // -------- COMPONENT LIFE-CYCLE EVENTS  --------------
  // ----------------------------------------------------
  ngOnInit() // ngAfterViewInit()
  {
    if (this.consoleLog) console.log('myfooter.ngOnInit - LifeCycle ' + ' - Page:' + this.pageName);
    this.Initialize("ngOnInit");
  }

  // this IS called -- just before the component is removed
  ngOnDestroy() 
  { 
    if (this.consoleLog) console.log('myfooter.ngOnDestroy - LifeCycle ' + ' - Page:' + this.pageName);
    this.subscriptions(false, "myfooter.ngOnDestroy - LifeCycle");
  }

  // ----------------------------------------------------
  // --------------  INITIALIZE   -----------------------
  // ----------------------------------------------------
  Initialize(context:string)
  {
    if (this.consoleLog) console.log('myfooter.Initialize ' + ' - Page:' + this.pageName);
    this.alertLevel = Constants.ALERT_LOW;
    //this.isNotification = this.globalProvider.NewNotifications.DisplayFlag;
    this.subscriptions(true, "myfooter.Initialize-" + this.pageName);

    this.isGpsWatching = this.geolocationProvider.isGpsWatching();
    this.isIpsWatching = this.geolocationProvider.isIpsWatching();
    //this.PanicShowStartButtonFlag = this.globalProvider?.AmbitConfig?.PanicShowStartButtonFlag;
  }

  // ----------------------------------------------------
  // ---------------      SUBSCRIPTIONS       -----------
  // ----------------------------------------------------
  subscriptions(isSubscribe:boolean, context:string)
  {
    if (this.consoleLog) console.log('myfooter.Subscriptions: ' + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - Page:' + this.pageName + " " + context);
    
    this.IsActivePanic(); // get current monitor status 
    this.SubscribeToGpsStatus(isSubscribe);
  }


  public SetGeofenceFlag(GeofenceFlag:boolean)
  {
    // clumsy way of passing the geofence flag into the footer's own copy of the geoinfo component
    this.mygeoinfocomponent.SetGeofenceFlag(GeofenceFlag);
  }
  
  SetInitialize()
  {
    if (this.consoleLog) console.log('myfooter.SetInitialize');
  }

  // ----------------------------------------------------
  // ------------  DISPLAY CONTROL BUTTONS  -------------
  // ----------------------------------------------------
  public btnToggleGeolocationDetails()
  {
    if (this.consoleLog) console.log("myfooter.btnToggleGeolocationDetails from " + this.showFooterGeo);
    this.toggleGeolocationDetails();
  }

  public toggleGeolocationDetails()
  {
    if (this.consoleLog) console.log("myfooter.toggleGeolocationDetails from " + this.showFooterGeo);
    this.showFooterGeo = !this.showFooterGeo;
    //this.globalProvider.UserAppConfig.ShowFooterGeoOnAllScreens = this.showFooterGeo;
    if (this.showFooterGeo)
    {
      this.mygeoinfocomponent.ShowGeofenceStatus(true);
      this.mygeoinfocomponent.ShowGeolocationInfo(true);
    }
  }

  public SetPanicModeOnlyAndPanicScreen(isPanicModeOnlyAndPanicScreen:boolean)
  {
    // alert("isPanicModeOnlyAndPanicScreen:" + isPanicModeOnlyAndPanicScreen);
    if (this.consoleLog) console.log("myfooter.SetPanicModeOnlyAndPanicScreen " + isPanicModeOnlyAndPanicScreen);
    this.isPanicModeOnlyAndPanicScreen = isPanicModeOnlyAndPanicScreen;
  }

  // ----------------------------------------------------
  // --------------  ORG ALERT LEVEL (NEW)  -------------
  // ----------------------------------------------------
  btnAlertLevel()
  {
    if (this.consoleLog) console.log("myfooter.btnAlertLevel " + this.alertLevel);

    if (this.alertLevel === Constants.ALERT_LOW)
    {
      this.alertMessage = "There are no known issues reported";
      this.TriggerAlertTest(Constants.ALERT_WARNING, 10);
    }
    else if (this.alertLevel === Constants.ALERT_WARNING)
    {
      this.alertMessage = "Possible weather disruption later today";
      this.TriggerAlertTest(Constants.ALERT_HIGH, 10);
    }
    else if (this.alertLevel === Constants.ALERT_HIGH)
    {
      this.alertMessage = "Fires reported nearby; please prepare to evacuate";
      this.TriggerAlertTest(Constants.ALERT_LOW, 10);
    }

    this.DisplayAlertInfo();
  }

  myTranslate(value:string):string
  {
    // WARNING! inline translation will CRASH if the value is empty
    if (!value) { return ""; }
    return this.translate.instant(value);
  }

  async DisplayAlertInfo()
  {
    const alert = await this.alertController.create(
    {
      header: this.myTranslate(this.alertLevel),
      //subHeader: this.myTranslate(this.alertLevel),
      message: this.myTranslate(this.alertMessage),
      buttons: [
        {
          text: this.myTranslate('OK'),
          handler: () => {
            if (this.consoleLog) console.log('myfooter.DisplayAlertInfo - Confirm end');
          }
        }
      ]
    });

    await alert.present();
  }

  TriggerAlertTest(alertLevel:string, secondsBeforeAlert:number) 
  {
    if (this.consoleLog) console.log("myfooter.TriggerAlertTest in " + secondsBeforeAlert + " seconds. " + " Currently :" + this.alertLevel );
		setTimeout(() => {
      console.log("myfooter.TriggerAlertTest time elapsed (" + secondsBeforeAlert + "). " + " Switching to:" + alertLevel );
      this.alertLevel = alertLevel;
    }, secondsBeforeAlert*1000);
  }

  // ----------------------------------------------------
  // --------------- MONITOR SEND API WATCH -------------
  // ----------------------------------------------------
  // https://forum.ionicframework.com/t/events-pub-sub-how-to-unsubscribe-in-lifecycle-hook/50596/5?u=xme

  public isActiveSubscriptionMonitorApi = false;
  private _MonitorApiEventSub: (isResponse:boolean) => void;
  DefineMonitorApiEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("myfooter.DefineMonitorApiEventSub");
    this._MonitorApiEventSub = (isResponse:boolean) => {
      if (this.consoleLog) console.log("myfooter.MonitorApiEventSub - isResponse: ", isResponse);
      this.onMonitorStatus();
    };
  }

  SubscribeToSendMonitorStatus_isResponse(isSubscribe:boolean)
  {   
    if (this.consoleLog) console.log("myfooter.SubscribeToSendMonitorStatus_isResponse: " + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - ' + this.pageName);

    if (isSubscribe)
    {
      if (this.isActiveSubscriptionMonitorApi === true)
      {
        if (this.consoleLog) console.log("myfooter.SubscribeToSendMonitorStatus_isResponse - ALREADY ACTIVE");
        return;
      }
      this.isActiveSubscriptionMonitorApi = true;
      //this.InitialMonitorStatus();
      this.DefineMonitorApiEventSub();
      this.events.subscribe('myfooter' + this.pageName, 'SendMobileMonitorStatus:isResponse', this._MonitorApiEventSub);
    }
    else
    {
      this.events.unsubscribe('myfooter' + this.pageName, 'SendMobileMonitorStatus:isResponse', this._MonitorApiEventSub);
      this.isActiveSubscriptionMonitorApi = false;
    }
  }
  onMonitorStatus()
  {
    this.zone.run(() => {
      if (this.consoleLog) console.log("myfooter.onMonitorStatus");
      this.IsActivePanic();
      //let apiResponse = this.monitoringProvider.GetApiResponse();
      //this.SetApiCallInfo(apiResponse, "ApiEventSubscription");
      // if (this.content) { this.content.resize(); }
    });
  }


  // ----------------------------------------------------
  // ----------------  PANIC HELP MONITOR  --------------
  // ----------------------------------------------------

  IsActivePanic():boolean
  {
    if (this.consoleLog) console.log("myfooter.IsActivePanic - before:" + this.isPanic);
    this.isPanic = this.monitoringProvider.IsPanic();

    this.zone.run(() => {
      this.isMonitoring = this.monitoringProvider.IsMonitoring();
      this.monitorSession = this.monitoringProvider.GetMonitorSession();
      this.isPanic = this.monitoringProvider.IsPanic();
      if (this.consoleLog) console.log("myfooter.IsActivePanic - now:" + this.isPanic + " isMonitoring:" + this.isMonitoring + " MobileMonitorTypeCode:" + this.monitorSession.MobileMonitorTypeCode);
    });

    return this.isPanic;
  }

  btnDisplayHealthRiskMessage()
  {
    console.log("myfooter.btnDisplayHealthRiskMessage: " + this.globalProvider.MobileUserProfile.HealthRiskFlag);
    
    // display the information as configured
    if (this.globalProvider?.OrganizationHealthRisk?.HealthRiskMessageDisplayTypeId === 1)
    {
      // Nothing to do: already displaying the information in the footer
    }
    else if (this.globalProvider?.OrganizationHealthRisk?.HealthRiskMessageDisplayTypeId === 2)
    {
      this.MessageDisplayFlag = ! this.MessageDisplayFlag;
    }
  }

  public MessageDisplayFlag: boolean = false;
  btnToggleHealthRiskMessageDisplay()
  {
    this.MessageDisplayFlag = ! this.MessageDisplayFlag;
  }

  btnShowDialogHealthRiskMessage()
  {
    this.openHealthRiskDialog();
  }

  async openHealthRiskDialog()
  {
    if (this.consoleLog) console.log("app.openHealthRiskDialog");

    const MessageTitle = this.globalProvider?.OrganizationHealthRisk?.HealthRiskMessageTitle;
    const MessageSubTitle = ""; // this.globalProvider?.OrganizationHealthRisk?.HealthRiskMessageSubTitle;
    const MessageText = this.globalProvider?.OrganizationHealthRisk?.HealthRiskMessageText;
    const browserUrl = this.globalProvider?.OrganizationHealthRisk?.HealthRiskExternalUrl;
    const buttonText = (browserUrl)? "More Information" : "OK";

    const alert = await this.alertController.create(
      { header: this.myTranslate(MessageTitle)
      , subHeader: this.myTranslate(MessageSubTitle)
      , message: this.myTranslate(MessageText)
      , buttons: [
        {
          text: this.myTranslate(buttonText),
          handler: () => {
            console.log('app.openHealthRiskDialog - OK');
            this.OpenHealthRiskExternalUrl();
            return;
          }
        }
      ]
    });
    await alert.present();
  }

  public btnOpenHealthRiskExternalUrl()
  {
    this.OpenHealthRiskExternalUrl();
  }

  OpenHealthRiskExternalUrl()
  {
    if (this.globalProvider?.OrganizationHealthRisk?.HealthRiskExternalUrl)
    {
      const browserUrl = this.globalProvider?.OrganizationHealthRisk?.HealthRiskExternalUrl;
      const browser = InAppBrowser.create(browserUrl, "_system");
      browser.show();
    }
  }

  public btnOpenHealthRiskPhoneNumber()
  {
    this.OpenHealthRiskPhoneNumber();
  }

  OpenHealthRiskPhoneNumber()
  {
    if (this.globalProvider?.OrganizationHealthRisk?.HealthRiskPhoneNumber)
    {
      const browserUrl = "tel:" + this.globalProvider?.OrganizationHealthRisk?.HealthRiskPhoneNumber;
      const browser = InAppBrowser.create(browserUrl, "_system");
      browser.show();
    }
  }

  public btnOpenHealthRiskEmailAddress()
  {
    this.OpenHealthRiskEmailAddress();
  }

  OpenHealthRiskEmailAddress()
  {
    if (this.globalProvider?.OrganizationHealthRisk?.HealthRiskEmailAddress)
    {
      const browserUrl = "mailto:" + this.globalProvider?.OrganizationHealthRisk?.HealthRiskEmailAddress;
      const browser = InAppBrowser.create(browserUrl, "_system");
      browser.show();
    }
  }


  // =============================================================

  btnStartPanic()
  {
    if (this.consoleLog) console.log("myfooter.btnStartPanic");

    if (this.IsActivePanic())
    {
      if (this.consoleLog) console.log("myfooter.btnStartPanic: already running");
      return;  // panic help monitor already running
    }

    // Either open page to confirm panic -- or -- immediately start without changing page
    if (this.globalProvider.IsShowPanicConfirmation() === true )
    {
      if (this.consoleLog) console.log("myfooter.btnStartPanic: show confirmation screen");
      this.HandlePanicConfirmation();
    }
    else
    {
      if (this.consoleLog) console.log("myfooter.btnStartPanic: auto start panic (activate)");
      this.HandlePanicAutoStart();
    }
  }

  HandlePanicAutoStart()
  {
    // NEED TO START MONITORING AT HELP LEVEL
    console.log("myfooter.btnStartPanic: start monitoring! " + " - Page:" + this.pageName);
    let EventSiteId:number = this.globalProvider.SiteProximity.GetNearestGeofenceSiteId();
    this.monitoringProvider.StartMonitorSession(Constants.MONITOR_HELP, EventSiteId);
    this.isMonitoring = true;
    this.isPanic = true;
    this.outIsDashboardRefresh.emit(true);
  }

  HandlePanicConfirmation()
  {
    console.log("myfooter.HandlePanicConfirmation: open screen for monitor to allow Panic Confirmation " + " - Page:" + this.pageName);
    this.globalProvider.SetPanicInitiatedFromAmbitAppFlag(true); //  this.globalProvider.NavData.PanicInitiatedFromAmbitAppFlag = true;
    //alert("myfooter.HandlePanicConfirmation PanicInitiatedFromAmbitAppFlag:" + this.globalProvider.GetPanicInitiatedFromAmbitAppFlag("myFooter.HandlePanicConfirmation"));
    console.log("myfooter.HandlePanicConfirmation PanicInitiatedFromAmbitAppFlag:" + this.globalProvider.GetPanicInitiatedFromAmbitAppFlag("myFooter.HandlePanicConfirmation"));
    
    this.outIsDashboardRefresh.emit(false); // false means we are not starting panic but rather confirming it
    this.DisplayPanicPage(true);
  }

  btnDisplayPanic() 
  {
    console.log("myfooter.btnDisplayPanic: open screen for monitor to allow viewing/ending " + " - Page:" + this.pageName);
    // ----------------------------------------------------------
    this.DisplayPanicPage(false);
    // ----------------------------------------------------------
  }

  DisplayPanicPage(isStartPanicButtonPressed:boolean)
  {// ----------------------------------------------------------
    let _NotificationData = new NotificationData();
    _NotificationData.NotificationSourceCode = Constants.NOTIFICATION_SOURCE_OTHER; 
    _NotificationData.NotificationTypeCode = Constants.NOTIFICATION_TYPE_MONITOR; // "SURVEY";
    _NotificationData.IsActive = this.IsActivePanic();   // we expect this to be true if this button is used
    _NotificationData.SurveyBroadcastId = 0;  // N/A
    _NotificationData.IsStartPanic = isStartPanicButtonPressed;
    console.log("myfooter.DisplayPanicPage _NotificationData", _NotificationData);
    this.notificationProvider.PublishNotificationAlert(_NotificationData);
    // ----------------------------------------------------------
  }


  btnNotification()
  {
    //  what to do here -- trigger modal opening in the app.component.ts?
    console.log("myfooter.btnNotification" + " - Page:" + this.pageName);
    alert("btnNotification - TBD" + " - Page:" + this.pageName);
  }


  // ----------------------------------------------------
  // --------------  NEW NOTIFICATIONS   ----------------
  // ----------------------------------------------------

  btnSurvey()
  {
    this.DisplaySurvey();
  }

  DisplaySurvey()
  {
    console.log('myfooter.DisplaySurvey: ' + this.SurveyBroadcastId + " - Page:" + this.pageName);
    /*
    this.navCtrl.setRoot(
        AttentionSurveyPagX
      , { SurveyBroadcastId: this.SurveyBroadcastId, item: null }
      , Constants.NAV_FORWARD
    ); 
    */
  }

  public isActiveSubscriptionGpsStatus = false;
  DefineGpsEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("myfooter.DefineGpsEventSub" + " - Page:" + this.pageName);
    this._GpsEventSub = (geoStatus:GeoStatus) => {
      if (this.consoleLog) console.log("myfooter.GpsEventSub - geoStatus: ", geoStatus);
      this.onGpsStatus(geoStatus);
    };
  }

  SubscribeToGpsStatus(isSubscribe:boolean)
  {   
    if (this.consoleLog) console.log("myfooter.GpsStatus: " + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + " - Page:" + this.pageName);

    if (isSubscribe)
    {
      //this.GpsStatus = this.geolocationProvider.GetGpsStatus();  // get initial status
      this.isGpsWatching = this.geolocationProvider.isGpsWatching();

      if (this.isActiveSubscriptionGpsStatus === true)
      {
        if (this.consoleLog) console.log("myfooter.GpsStatus - ALREADY ACTIVE");
        return;
      }
      this.isActiveSubscriptionGpsStatus = true;
      this.DefineGpsEventSub();  // call this first before subscribing to the event
      this.events.subscribe('myfooter' + this.pageName, 'geolocation:gpsStatus', this._GpsEventSub);

      /*
      this.GpsPosition = this.geolocationProvider.GetGpsPosition();  // get initial position
      this.onGpsResponse(this.GpsPosition);

      //if (this.consoleLog) console.log("Map.SubscribeToGps SUBSCRIBE");
      this.GpsSubscription = this.geolocationProvider.gpsObservable.subscribe(
        (geoPosition: GeoPosition) => { this.onGpsResponse(geoPosition); }
      , (error: any)       => { this.onGpsError(error); }
      );
      */
    }
    else
    {
      //console.log("myfooter.GpsSubscription BEFORE UNSUBSCRIBE", this.GpsSubscription);
      //this.GpsSubscription.unsubscribe();
      //console.log("myfooter.GpsSubscription AFTER UNSUBSCRIBE", this.GpsSubscription);
      
      //console.log("myfooter.gpsStatus: BEFORE UNSUBSCRIBE" + ' - ' + this.pageName, this.events);
      this.events.unsubscribe('myfooter' + this.pageName, 'geolocation:gpsStatus', this._GpsEventSub);
      this.isActiveSubscriptionGpsStatus = false;
      //console.log("myfooter.gpsStatus: AFTER UNSUBSCRIBE" + ' - ' + this.pageName, this.events);
    }
  }

  /*
  onGpsResponse(geoPosition:GeoPosition) 
  {
    if (this.consoleLog) console.log("myfooter.onGpsResponse" + " - Page:" + this.pageName, geoPosition);
    this.zone.run(() => {
      this.isGpsWatching = this.geolocationProvider.isGpsWatching();
      this.GpsPosition = geoPosition;
      this.GpsStatus = geoPosition.GeoStatus; // this.geolocationProvider.GetGpsStatus();  
    });
  }

  onGpsError(error:any) 
  {
    console.error("myfooter.onGeolocationError" + " - Page:" + this.pageName, error);
    this.zone.run(() => {
      // this should be trapped in the Provider and not here, but let's handle it anyway just in case...
      this.GpsStatus.Success = false;  
      this.GpsStatus.ResultText = "GPS error";  
      this.GpsStatus.ResultCode = "GPS88";  
      if ((error) && (error.message)) { this.GpsStatus.ResultText = error.message; }
      if ((error) && (error.code)) { this.GpsStatus.ResultCode = error.code; }
      //this.outGpsStatus.emit(this.GpsStatus);  // send to parent page
      //this.outIsGpsWatching.emit(this.GpsStatus.ActiveWatch);
      
      //if (this.content) { this.content.resize(); }
    });
  }
  */

  onGpsStatus(geoStatus:GeoStatus)
  {
    if (this.consoleLog) console.log("myfooter.onGpsStatus" + " - Page:" + this.pageName, geoStatus);
    this.zone.run(() => {
      //this.GpsStatus = geoStatus;
      this.isGpsWatching = geoStatus.ActiveWatch; // this.geolocationProvider.isGpsWatching();
    });
  }

  public RefreshGpsStatus()
  {
    // allow parent page to force an inquiry, say on its page initialization
    if (this.consoleLog) console.log("myfooter.RefreshGpsStatus" + " - Page:" + this.pageName);
    this.zone.run(() => {
      //this.GpsStatus = this.geolocationProvider.GetGpsStatus();
      this.isGpsWatching = this.geolocationProvider.isGpsWatching();
    });
  }

  // ----------------------------------------------------
  // ----------  HEADER LOCATION INFO          ----------
  // ----------------------------------------------------
  public btnHeaderLocation()
  {
    if (this.consoleLog) console.log("myfooter.btnHeaderLocation" + " - Page:" + this.pageName);

    try
    {
      this.AlertHeaderLocation();
    }
    catch (error)
    {
      console.error("myfooter.btnHeaderLocation" + " - Page:" + this.pageName + " ERROR:" + error.message, error);
    }
  }

  async AlertHeaderLocation() 
  {
    // if (this.consoleLog) 
    console.log("myfooter.AlertHeaderLocation" + " - Page:" + this.pageName);

    let btnDetailsText:string = "Show Details";
    if (this.showFooterGeo === true)
    {
      btnDetailsText = "Hide Details";
    }

    let watchList = this.geolocationProvider.getWatchDependencyList();
    let ipsLocation = "";

    if (this.geolocationProvider.isLocationIndoors())
    {
      ipsLocation = " " + this.myTranslate("IPS");
    }

    // if (this.consoleLog) 
    console.log("myfooter.AlertHeaderLocation" + " - Page:" + this.pageName + " create dialog box");
    const alert = await this.alertController.create(
      { header: this.myTranslate('Location-Watch List') + ipsLocation
      , subHeader: this.myTranslate('Features actively using location') + ":"
      , message: watchList
      , buttons: [
        { text: this.myTranslate(btnDetailsText)
        , handler: () => 
          { 
            console.log('ValidationAlert Show/Hide clicked: ' + btnDetailsText); 
            this.toggleGeolocationDetails();
          }
        }
        ,
        { text: this.myTranslate('OK')
        //, role: 'cancel'
        , handler: () => 
          { 
            console.log('ValidationAlert OK clicked'); 
          }
        }
      ]
    });
    await alert.present(); 
  }


  // ----------------------------------------------------
  // ---------- MOBILE USER PROFILE ACCOUNT  ------------
  // ----------------------------------------------------

  btnShowProfile()
  {
    console.log("ActionsMonitor.btnShowProfile"); 
    let url:string = '/useraccount';
    this.AlertProfile(url);

    // use this as an opportunity to reset the Ambit Config
    // if the app is in panic mode, but maybe the server hsa reset the user's config, let's refresh it 
    this.CallGetDashboardStatusForMobile();
  }

  async AlertProfile(url:string) 
  {
    if (this.consoleLog) console.log("ActionsMonitor.AlertProfile - " + url);

    const alert = await this.alertController.create(
      { header: this.globalProvider.MobileUserProfile.MobileUserDisplayName
      , subHeader: this.globalProvider.MobileUserProfile.OrganizationName
      , message: this.myTranslate('View full account details, or cancel')
      , buttons: [
        { text: this.myTranslate('Cancel')
        , handler: () => 
          { 
            console.log('Cancel clicked'); 
          }
        }
        ,
        { text: this.myTranslate('My Account')
        //, role: 'cancel'
        , handler: () => 
          { 
            console.log('Confirm UserAccount clicked'); 
            this.router.navigateByUrl(url); 
          }
        }
      ]
    });
    await alert.present(); 
  }

  CallGetDashboardStatusForMobile()
  {
    if (this.consoleLog) console.log("ActionsMonitor.CallGetDashboardStatusForMobile");
    this.apiProvider.GetDashboardStatusForMobile()
    .then(data => { 
      this.zone.run(() => {
        // we are just making sure the AmbitConfig values get updated in PanicMode
      });
     }
    , 
    errorMessage => {
      this.zone.run(() => {
        //this.isPageReady = false;
      });
    });
  }

}
